import React from 'react';
import { UnbookInvoiceActivity } from '../../../../../model/activity';
import './ActivityItems.css';
import { KeyValueTable } from '../../../../../components/KeyValueTable/KeyValueTable';
import { t } from '../../../../../locales/translate';
import { formatDateTime } from '../../../../../util/util';
import { assetPath } from '../../../../../routes';
import { Icon } from '../../../../../components/Icon/Icon';

export function UnbookInvoiceActivity({ activity }: { activity: UnbookInvoiceActivity }): JSX.Element | null {
  if (!activity.modifications) return null;

  const { bookedAt, bookingNumber, pdfAssetId } = activity.modifications.previous;
  return (
    <div className="unbookInvoice">
      <KeyValueTable
        fullWidth={false}
        items={[
          {
            key: t.model.invoice.bookedAt,
            value: formatDateTime(bookedAt),
          },
          {
            key: t.model.invoice.bookingNumber,
            value: bookingNumber,
          },
          {
            key: t.model.invoice.previousInvoicePdf,
            value: pdfAssetId && (
              <>
                <a href={assetPath(pdfAssetId, 'pdf')} target="_blank" rel="noopener noreferrer">
                  <Icon name="external-link--sm" />
                </a>
              </>
            ),
          },
        ]}
      />
    </div>
  );
}
